<template>
<div style="position:relative">
    <v-form ref="form" v-model="valid">
    <div style="background-color:white;position:absolute;top:0px;right:0px;z-index:1000">
        <ImageEditor :item="contact" />
    </div>
    <v-text-field @change="checkGenderAndDuplicates" ref="firstName" v-model="contact.firstName" label="First Name" :rules="requiredRules" />
    <v-text-field v-if="advanced" v-model="contact.preferredName" label="Preferred Name"  />


    <v-text-field v-model="contact.lastName" @change="checkDuplicates" label="Last Name" :rules="requiredRules"/>
    <UniqueContactEnforcer ref="enforcer" :contact="contact"/>
    <!-- <div v-show="tenantKey !== '007' ">  -->
            <!-- For Aussie Morayfield hide contact details -->
        <v-text-field v-if="advanced || contact.business" v-model="contact.business" label="Business" />
        <v-text-field v-if="advanced || contact.phone" v-model="contact.phone" label="Phone" />
        <v-text-field v-model="contact.mobile" label="Mobile" :rules="mobileRules" />
        <v-text-field v-if="advanced || contact.fax" v-model="contact.fax" label="Fax " />
        <v-text-field v-if="advanced || contact.address" v-model="contact.address" label="Address " />
        <EmailBox ref="email" v-model="contact.email" :hide-details="false" />
    <!-- </div> -->
    <v-combobox multiple :value="selectedGroups" @input="updateGroups" label="Groups" chips :items="availableGroups" />
    <v-textarea v-if="advanced" v-model="contact.notes" label="Notes" />
    <v-btn v-if="!advanced" @click="advanced=true" color="primary" text><v-icon>keyboard_arrow_down</v-icon>Advanced</v-btn>
    <v-select v-if="advanced" clearable v-bind:items="['Male', 'Female', 'Other']" @change="checkImage" v-model="contact.gender" label="Gender"/>
    <v-text-field v-if="advanced" v-model="contact.middleName" label="Middle Name" />
    <DateTime v-if="advanced" date-only v-model="contact.dob" label="Date of Birth" short/>        
    <v-select clearable v-bind:items="users" v-model="contact.owner" label="Owner" item-text="meta.fullName" item-value="key" return-object />
    <v-select :disabled="Boolean(contact.meta.key)" v-bind:items="officesList" v-model="contact.meta.tenantKey" label="Office" item-text="name" item-value="meta.key" />  
    </v-form>
</div>
</template>

<script>
import ContactHelpers from '../helpers/ContactHelpers'
import CloudHelpers from '../helpers/CloudHelpers'
import DataHelpers from '../helpers/DataHelpers'
import Utilities from '../helpers/Utilities'
import ImageEditor from './ImageEditor'
import UniqueContactEnforcer from '../ui-elements/UniqueContactEnforcer'
import StringHelpers from '../helpers/StringHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import EmailBox from '../ui-elements/EmailBox'
import DateTime from '../ui-elements/DateTime'

export default {
    data() {
        return {
            valid: true,
            imageObj: {},
            advanced: false,
            imageObject: {},
            groupsArray: [],
            requiredRules: [
                v => (v && v.length > 1) || 'Required'
            ],
            emailRules: [
                v => (!v || StringHelpers.isEmail(v)) || 'Enter a valid email'
            ],
            mobileRules: [
                v => (!v || StringHelpers.isMobileNumber(v)) || 'Enter a valid mobile'
            ],
            emailValidationError: '',
            ignoreEmailValidationErrors: false,
        }
    },
    
    props: {
        contact: Object,
    },

    components: { 
        ImageEditor, UniqueContactEnforcer, EmailBox, DateTime,
    },

    asyncComputed: {
        users() {
            if(!this.tenantKey)
                return []

            return ContactHelpers.fetchUsersForOffice(this.tenantKey).then(users => {
                
                return users.map(o => {
                    let user = {
                        key: o.meta.key,
                        firstName: o.firstName,
                        lastName: o.lastName,
                        meta: {fullName: ContactHelpers.fullName(o)}
                    }
                    return user
                })
                
            })
        }
    },

    computed: {
        officesList() {
            return this.$store.getters.officesActive
        }, 

        availableGroups() {
            return this.$store.getters.groups.map(o => o.name)
        },

        selectedGroups() {
            if(this.contact && this.contact.groups)
                return Utilities.objectToArray(this.contact.groups)
            else
                return null
        },

        tenantKey() {
            return this.$store.getters.tenantKey
        },


    },

    methods: {

        validate() {
            return (
                this.$refs.form.validate() && 
                this.$refs.email.validate()
            )
        },

        checkGenderAndDuplicates() {
            this.checkGender()
            this.checkDuplicates()
        },

        checkDuplicates() {
            this.$refs.enforcer.check()
        },

        fullName(contact) {
            let c =  ContactHelpers.fullName(contact)
            return c
        },

        setInitialFocus() {
            this.$refs.form.resetValidation()
            this.emailValidationError = ''
            setTimeout( () => {
                this.$refs.firstName.focus()

            }, 1000)
        },

        updateGroups(e) {
            console.log('ContactDetails > updateGroups', e)
            this.contact.groups = Utilities.arrayToObject(e)
        },


        checkGender() {
            if(!this.contact.gender)
                ContactHelpers.setInitialGender(this.contact)
        },   
        
        checkImage() {
            if(this.contact.image.indexOf('random') > -1) {
                this.contact.image = ContactHelpers.getGenderImage(this.contact.gender)
            }
        },

        uploadComplete() {
            console.log('upload complete')
        },

        collapse() {
            console.log('collapsing advanced section....')
            this.advanced = false
        }
    },

    watch: {
        'contact.meta.key': function(newVal) {   
            this.collapse()
        },
    },

    created() {
        this.$store.dispatch('fetchAllGroups')
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// ContactDetails.vue?070e8543